<template>
    <div style="margin: 1rem 3rem 4rem 3rem;text-align: center">
        <div style="background-color: crimson;color: #ffffff;padding: 10px 30px;font-weight: lighter" @click="click">
            {{value}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "myBtn",
        props:{
            value:''
        },
        methods:{
            click(){
                this.$emit('click')
            }
        }
    }
</script>

<style scoped>

</style>